import { IParamActionValidator } from "../../../../common/component/action/action-select/interface-param-action-validator";
import { ParamActionValidationResult } from "../../../../common/component/action/action-select/param-action-validation-result";
import { PalletsListItem } from "../pallets-list/pallets-list-item";
import { t } from "i18next";

class PalletShippingParamActionValidator implements IParamActionValidator<PalletsListItem> {
    public validate(pallets: PalletsListItem[]) {
        return pallets.some(p => p.isVirtualPallet !== pallets[0].isVirtualPallet) ?
            ParamActionValidationResult.error(t("palletShipping.action.ship.validation.mixedPalletType")) :
            ParamActionValidationResult.success(pallets);
    }
}

export const palletShippingParamActionValidator = new PalletShippingParamActionValidator();
